import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { MotionConfig } from 'framer-motion'
import type { PropsWithChildren } from 'react'
import { useEffect } from 'react'

import { AuthProvider } from '@/contexts/AuthProvider'
import { DURATION, EASE } from '@/lib/motion'
import { useUiStore } from '@/store/useUiStore'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
})

function SettingsBridge() {
  const motionPreference = useUiStore((state) => state.motionPreference)

  useEffect(() => {
    document.documentElement.style.scrollBehavior = motionPreference === 'reduce' ? 'auto' : 'smooth'
  }, [motionPreference])

  return null
}

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <MotionConfig reducedMotion="user" transition={{ duration: DURATION.base, ease: EASE }}>
          {children}
          <SettingsBridge />
        </MotionConfig>
      </AuthProvider>
    </QueryClientProvider>
  )
}
